import { getCachedMember } from '@tribeplatform/react-sdk/hooks';
import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberKey, getMembersKey, getNetworkKey } from '../../utils/keys';
import { getAuthTokenKey, getAuthMemberKey, } from '../../utils/keys/authToken.keys';
import { useAuthMember } from '../auth/useAuthMember';
export const useUpdateMember = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const { data: authMember } = useAuthMember();
    return useMutation((input) => client.members.update(input, fields), {
        onMutate: async (variables) => {
            const memberInput = variables.input;
            const memberKey = getMemberKey({ variables: { id: variables.id } });
            await queryClient.cancelQueries(memberKey);
            const snapshot = getCachedMember(variables.id, queryClient);
            queryClient.setQueriesData(memberKey, old => ({
                ...old,
                ...memberInput,
                attributes: {
                    ...old === null || old === void 0 ? void 0 : old.attributes,
                    ...memberInput === null || memberInput === void 0 ? void 0 : memberInput.attributes,
                },
            }));
            const membersKey = getMembersKey();
            queryClient.setQueriesData(membersKey, old => {
                var _a;
                return ({
                    ...old,
                    pages: (_a = old === null || old === void 0 ? void 0 : old.pages) === null || _a === void 0 ? void 0 : _a.map(page => {
                        var _a, _b;
                        return ({
                            ...page,
                            nodes: (_a = page === null || page === void 0 ? void 0 : page.nodes) === null || _a === void 0 ? void 0 : _a.map(member => {
                                var _a, _b;
                                return ({
                                    ...member,
                                    flagged: (variables === null || variables === void 0 ? void 0 : variables.id) === (member === null || member === void 0 ? void 0 : member.id)
                                        ? (_b = (_a = variables === null || variables === void 0 ? void 0 : variables.input) === null || _a === void 0 ? void 0 : _a.flagged) !== null && _b !== void 0 ? _b : member.flagged
                                        : member.flagged,
                                });
                            }),
                            edges: (_b = page === null || page === void 0 ? void 0 : page.edges) === null || _b === void 0 ? void 0 : _b.map(edge => {
                                var _a, _b, _c, _d, _e;
                                return ({
                                    ...edge,
                                    node: {
                                        ...edge === null || edge === void 0 ? void 0 : edge.node,
                                        flagged: (variables === null || variables === void 0 ? void 0 : variables.id) === ((_a = edge === null || edge === void 0 ? void 0 : edge.node) === null || _a === void 0 ? void 0 : _a.id)
                                            ? (_c = (_b = variables === null || variables === void 0 ? void 0 : variables.input) === null || _b === void 0 ? void 0 : _b.flagged) !== null && _c !== void 0 ? _c : (_d = edge === null || edge === void 0 ? void 0 : edge.node) === null || _d === void 0 ? void 0 : _d.flagged
                                            : (_e = edge === null || edge === void 0 ? void 0 : edge.node) === null || _e === void 0 ? void 0 : _e.flagged,
                                    },
                                });
                            }),
                        });
                    }),
                });
            });
            return { snapshot };
        },
        onSuccess: (updatedMember, vars, context) => {
            var _a;
            const memberKey = getMemberKey({ variables: { id: updatedMember.id } });
            queryClient.setQueriesData(memberKey, oldMember => ({
                ...oldMember,
                ...updatedMember,
            }));
            if (authMember.id === updatedMember.id) {
                const authMemberKey = getAuthMemberKey();
                queryClient.setQueriesData(authMemberKey, oldMember => ({
                    ...oldMember,
                    ...updatedMember,
                }));
            }
            (_a = useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onSuccess) === null || _a === void 0 ? void 0 : _a.call(useMutationOptions, updatedMember, vars, context);
        },
        onError: (err, newMember, context) => {
            var _a;
            const memberKey = getMemberKey({ variables: { id: newMember.id } });
            queryClient.setQueriesData(memberKey, context.snapshot);
            queryClient.invalidateQueries(memberKey);
            (_a = useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError) === null || _a === void 0 ? void 0 : _a.call(useMutationOptions, err, newMember, context);
        },
        onSettled: () => {
            const membersKey = getMembersKey();
            const authTokenKey = getAuthTokenKey();
            const networkKey = getNetworkKey();
            queryClient.invalidateQueries(membersKey);
            queryClient.invalidateQueries(authTokenKey);
            queryClient.invalidateQueries(networkKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateMember.js.map